




import Vue from "vue";

export default Vue.extend({
  name: "Text",
  props: {
    fontStyle: {
      type: String,
      default: "normal"
    },
    fontWeight: {
      type: String,
      default: "normal"
    },
    fontSize: {
      type: String,
      default: "normal"
    },
    lineHeight: {
      type: String,
      default: "normal"
    },
    color: {
      type: String,
      default: "var(--quaternary-color)"
    },
    textAlign: {
      type: String,
      default: "left"
    },
    value: {
      type: String,
      default: "Default value"
    }
  },
  computed: {
    style() {
      return {
        fontStyle: this.fontStyle,
        fontWeight: this.fontWeight,
        fontSize: this.fontSize,
        lineHeight: this.lineHeight,
        color: this.color,
        textAlign: this.textAlign
      };
    }
  }
});
